import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import HeaderColumn from './HeaderColumn';
import HeaderRow from './HeaderRow';

/**
 * Header di un component Table.
 */
const Header = ({ children, className }) => (
  <thead className={cns('table__head', className)}>
    {children}
  </thead>
);

Header.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
};

Header.defaultProps = {
  children: null,
  className: '',
};

Header.Row = HeaderRow;
Header.Column = HeaderColumn;

export default Header;
